import Phaser from 'phaser';
import { buildTextures } from '../systems/textures';

export default class PreloadScene extends Phaser.Scene {
  constructor() {
    super('PreloadScene');
  }

  create() {
    buildTextures(this);
    const target = this.registry.get('startLevel') || 'LevelOneScene';
    this.scene.start(target);
    this.scene.launch('UIScene');
  }
}
